import { render, staticRenderFns } from "./informationPriceNumDialog.vue?vue&type=template&id=885caa6a&scoped=true"
import script from "./informationPriceNumDialog.vue?vue&type=script&lang=js"
export * from "./informationPriceNumDialog.vue?vue&type=script&lang=js"
import style0 from "./informationPriceNumDialog.vue?vue&type=style&index=0&id=885caa6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "885caa6a",
  null
  
)

export default component.exports